import { isArray, isBoolean, merge } from 'lodash';

import { IProviderSource } from '@assess/shared/data-mart';

import { IProviderSearchBody } from '../interfaces/provider/provider-search-body.types';
import { SearchBody } from '../types/search-body.types';

export interface ITransformedBodyFilters extends Partial<Pick<IProviderSource, 'ActiveInd' | 'Specialty'>> {}

export const processProviderBody = (body?: Partial<IProviderSearchBody>): Partial<SearchBody> => {
  body ??= {};

  const { filters: _filters, ...rest } = body;

  return merge({}, rest, preprocessFilters(body), preprocessQuery(body));
};

const preprocessFilters = (body: Partial<IProviderSearchBody>) => {
  const { filters: bodyFilters } = body;
  const filters: ITransformedBodyFilters = {};

  if (isBoolean(bodyFilters?.active)) {
    filters.ActiveInd = bodyFilters?.active ? 'Y' : 'N';
  }

  filters.Specialty = bodyFilters?.specialty;

  return { filters };
};

const preprocessQuery = (body: IProviderSearchBody) => {
  const { filters: bodyFilters, query: bodyQuery } = body;
  const queries = [];

  if (bodyFilters?.exists && isArray(bodyFilters?.exists)) {
    const existsQueries = bodyFilters.exists.filter((e) => Boolean(e?.trim())).map((e) => `_exists_:${e}`);

    queries.push(...existsQueries);
  }

  return { query: [...queries, bodyQuery].filter((q) => Boolean(q?.trim())).join(' ') };
};
